import { Component, OnInit, Inject, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarService } from '../../services/calendar.service';
import { switchMap } from 'rxjs/operators';
import { of, EMPTY, Subscription } from 'rxjs';
import { BookingStepService } from '../../../booking/services/booking-step.service';
import { BookingSlotSelectPolicyEnum } from 'src/app/modules/booking/services/booking-slot-select-policy.enum';

@Component({
  selector: 'app-time-slot-calendar-popup',
  templateUrl: './time-slot-calendar-popup.component.html',
  styleUrls: ['./time-slot-calendar-popup.component.css']
})
export class TimeSlotCalendarPopupComponent implements OnInit, OnDestroy {

  calendarService: CalendarService;

  private _dateSelectionSubscription: Subscription;
  @Output()
  updatedBookingSlotEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<TimeSlotCalendarPopupComponent>,
    private bookingStepService: BookingStepService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.calendarService = data.calendarService;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._unsubscribeShiftSlotSubscription();
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  dateSelected(date: Date, isClose: boolean): void {
    this._unsubscribeShiftSlotSubscription();
    const searchDirection = date < this.calendarService.selectedDate ? -1 : 1 ;
    this._dateSelectionSubscription = this.bookingStepService.canResetOrderQuestionPopup()
      .pipe(
        switchMap(
          result => {
            if (!result) {
              return EMPTY;
            }

            return this.calendarService.dateSelect(date, BookingSlotSelectPolicyEnum.FirstSlot, searchDirection);
          }
        )
      )
      .subscribe(
        _ => {
          this.updatedBookingSlotEvent.emit();

          if (isClose) {
            this.closeClick();
          }
        });
  }

  _unsubscribeShiftSlotSubscription(): void {
    if (this._dateSelectionSubscription) {
      this._dateSelectionSubscription.unsubscribe();
      this._dateSelectionSubscription = null;
    }
  }
}
